export default __webpack_public_path__ + "static/media/toolsathand.63455bd4.png";